var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199,
    height: 117,
    viewBox: "0 0 199 117",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solution-1-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "solution-1",
    d: "M198.375 35.1699C187.542 35.1699 177.152 39.4734 169.492 47.1338C161.831 54.7941 157.528 65.1837 157.528 76.017C157.528 86.8504 161.831 97.24 169.492 104.9C177.152 112.561 187.542 116.864 198.375 116.864V35.1699Z",
    fill: "#414345"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "solution-2-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "solution-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.528 23.7354C145.187 23.7354 133.351 28.6378 124.625 37.3643C115.899 46.0907 110.996 57.9263 110.996 70.2674C110.996 82.6084 115.899 94.4441 124.625 103.171C133.351 111.897 145.187 116.799 157.528 116.799L157.528 23.7354Z",
    fill: "#777A7D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "solution-3-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "solution-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.996 12.2998C97.147 12.2998 83.8654 17.8012 74.0728 27.5938C64.2802 37.3864 58.7788 50.6679 58.7788 64.5167C58.7788 78.3655 64.2802 91.6471 74.0728 101.44C83.8654 111.232 97.147 116.734 110.996 116.734L110.996 12.2998Z",
    fill: "#9DA0A4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "solution-4-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "solution-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7788 0.864258C43.4223 0.864258 28.6947 6.96461 17.836 17.8233C6.97731 28.682 0.876954 43.4096 0.876953 58.7661C0.876953 74.1226 6.97731 88.8502 17.836 99.7089C28.6947 110.568 43.4223 116.668 58.7788 116.668V0.864258Z",
    fill: "#CDD0D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/solution.1c0246f241ceb74479c370915fed5e77.svg";
export { ForwardRef as ReactComponent };